import type { PageTitle } from './currentPageTitle';

const homePaths = ['/', '/en', '/id', '/th', '/zh'];
const jdvPaths = ['/job/', '/expiredjob/'];

export const pathToPageTitle = (path?: string): PageTitle | undefined => {
  if (!path) {
    return;
  }

  if (jdvPaths.some((jdvPath) => path.includes(jdvPath))) {
    return 'job details';
  }

  if (homePaths.includes(path)) {
    return 'home';
  }

  if (path.includes('jobs')) {
    return 'search results';
  }

  return;
};
